import { render } from "./video-games.vue?vue&type=template&id=c2f613d8"
import script from "./video-games.vue?vue&type=script&lang=js"
export * from "./video-games.vue?vue&type=script&lang=js"
script.render = render

export default script